import { MarkedUnitsPage } from "./MarkedUnits";

const RecentlyAssignedUnits = () => <MarkedUnitsPage mode="recent" />;

export default RecentlyAssignedUnits;
